export default "__VITE_ASSET__ndRfPqn6__"